exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".messages {\n  position: fixed;\n  width: 100%;\n  z-index: 9999; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/front/core/notifications/notifications.component.scss
// module id = 571
// module chunks = 1